import MagazineRelatedArticles from '@uikit/components/Magazine/MagazineRelatedArticles/MagazineRelatedArticles';
import { SectionVariant } from '@uikit/components/Section/consts';
import Section from '@uikit/components/Section/Section';
import type { MagazineRelatedArticlesWrapperProps } from './interfaces';

const MagazineRelatedArticlesWrapper = ({
  items,
}: MagazineRelatedArticlesWrapperProps) => {
  return (
    <Section variant={SectionVariant.LargePadding} noSpaceBetween withShadow>
      {items && (
        <MagazineRelatedArticles
          title={'Verwandte Artikel'}
          subTitle={'Diese Themen könnten Sie auch interessieren.'}
          items={items}
        />
      )}
    </Section>
  );
};

export default MagazineRelatedArticlesWrapper;
